import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
  useTheme,
} from "@mui/material";
import DataTable from "../../components/DataTable";
import { motion } from "framer-motion";
import { ClientResponse, User, UserResponse } from "../../types/api.types";
import { clientService } from "../../services/client/clientService";
import SyncIcon from "@mui/icons-material/Sync";

const ClientPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [currentPage, setCurrentPage] = useState(0);

  const theme = useTheme();

  const columns = [
    {
      header: "Nombre comercial",
      key: "comercialName",
    },
    {
      header: "Nombre legal",
      key: "legalName",
    },
    {
      header: "Email",
      key: "email",
    },
    {
      header: "Cuit",
      key: "cuit",
    },
    {
      header: "Estado",
      key: "visible",
      render: (value: any) => {
        return (
          <Chip
            label={value?.visible ? "Activo" : "Inactivo"}
            size="small"
            sx={{
              backgroundColor: value?.visible
                ? theme.palette.primary.main + "20"
                : theme.palette.error.main + "20",
              color: value?.visible
                ? theme.palette.primary.main
                : theme.palette.error.main,
              fontWeight: "600",
              border: `1px solid ${
                value?.visible
                  ? theme.palette.primary.main + "40"
                  : theme.palette.error.main + "40"
              }`,
              borderRadius: 2,
            }}
          />
        );
      },
    },
  ];

  const [clients, setClients] = useState<ClientResponse | null>(null);

  const getClients = async () => {
    setIsLoading(true);
    const response = await clientService.getClients(currentPage, 10);
    setClients(response);
    setIsLoading(false);
  };

  const onSyncClients = async () => {
    setIsLoading(true);
    await clientService.syncClients();
    await getClients();
    setIsLoading(false);
  };

  useEffect(() => {
    getClients();
  }, [currentPage]);

  return (
    <Box>
      <Card>
        <CardContent>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <Typography variant="h4">Clientes</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SyncIcon />}
                onClick={onSyncClients}
                disabled={isLoading}
                loading={isLoading}
              >
                Sincronizar Clientes
              </Button>
            </Box>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
            style={{ marginTop: 2 }}
          >
            <DataTable
              isLoading={isLoading}
              columns={columns}
              total={clients?.total || 0}
              data={clients?.clients || []}
              page={currentPage + 1}
              onChange={(page) => {
                setCurrentPage(page - 1);
              }}
            />
          </motion.div>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ClientPage;
